export enum Flag {
  IS_ADMIN = 0b01,
}
